import React, { useEffect } from "react";

import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { isLoggedIn } from "../../Stores/redux/Persisted/Selectors";

const MainScreen = ({ isLoggedIn, children, user }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/login");
    }
  }, [isLoggedIn, navigate]);

  if (!isLoggedIn || !user)
    return (
      <div
        style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div className="loader large"></div>
      </div>
    );

  return (
    <div className="mainwrapper">
      <div className="gaouter">{children}</div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  isLoggedIn: isLoggedIn(state),
  user: state.pState.AUTH?.user,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(MainScreen);
